import * as React from "react";
import pluginRegistry, {ActionEditProps} from "components/Actions/pluginRegistry";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import TomcatFeatureTemplate, {TomcatDeployProperties} from "components/Actions/tomcat/tomcatFeatureTemplate";
import styles = require("./style.less");

class DeployToTomcatFeature extends BaseComponent<ActionEditProps<TomcatDeployProperties>, never> {
    render() {
        return <TomcatFeatureTemplate
            projectId={this.props.projectId}
            properties={this.props.properties}
            plugin={this.props.plugin}
            setProperties={this.props.setProperties}
            doBusyTask={this.props.doBusyTask}
            getFieldError={this.props.getFieldError}
            errors={this.props.errors}
        />;
    }
}

pluginRegistry.registerFeature({
    featureName: "Octopus.Features.TomcatDeployManager",
    title: "Tomcat deployment feature",
    description: "Deploys packages to Tomcat via the manager API",
    edit: DeployToTomcatFeature,
    priority: 1
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/tomcat/deployToTomcatFeature.tsx